var regex = {};

export { regex as __exports };
//# sourceMappingURL=regex.js.map
